import { create } from 'zustand';
import { MyAlbumEntry } from '../types';
import { albumsApi } from '../api/albums';

interface AlbumStoreState {
  myAlbums: MyAlbumEntry[];
  loading: boolean;
  initialized: boolean;
  fetchMyAlbums: () => Promise<void>;
  invalidate: () => void;
}

export const useAlbumStore = create<AlbumStoreState>((set, get) => ({
  myAlbums: [],
  loading: false,
  initialized: false,

  fetchMyAlbums: async () => {
    if (get().loading) return;
    set({ loading: true });
    try {
      const { albums } = await albumsApi.myAlbums();
      set({ myAlbums: albums, loading: false, initialized: true });
    } catch {
      set({ loading: false, initialized: true });
    }
  },

  invalidate: () => set({ initialized: false }),
}));
